import React from 'react';
import { useLocation } from 'react-router-dom';
import './TopBar.css';

const ROUTE_TITLES = {
  '/dashboard':              'Main Dashboard',
  '/dashboard-classic':      'Dashboard',
  '/dashboard-v2':           'Operations Dashboard',
  '/business-transactions':  'Business Transactions',
  '/alerts':                 'Alerts',
  '/incidents':              'Incidents',
  '/post-incident-reviews':  'Post-Incident Reviews',
  // '/github-prs':             'GitHub Pull Requests',
  '/organisations':          'Organisation Management',
  '/tenants':               'Organisation Management',
  '/finance/dashboard':      'Finance Dashboard',
  '/finance/records':        'Finance Records',
};

// Pages that already have their own internal top section — skip the global bar
const NO_TOPBAR_PREFIXES = ['/dashboard', '/dashboard-v2'];

function isNoTopbar(pathname) {
  return NO_TOPBAR_PREFIXES.some(p => pathname === p || pathname.startsWith(p + '/'));
}

function getTitle(pathname) {
  if (ROUTE_TITLES[pathname]) return ROUTE_TITLES[pathname];
  for (const [route, title] of Object.entries(ROUTE_TITLES)) {
    if (pathname.startsWith(route + '/')) return title;
  }
  return 'Developer Tool';
}

function TopBar() {
  const { pathname } = useLocation();

  if (isNoTopbar(pathname)) return null;

  return (
    <header className="topbar">
      <div className="topbar-left">
        <div className="topbar-accent" />
        <h2 className="topbar-title">{getTitle(pathname)}</h2>
      </div>
    </header>
  );
}

export default TopBar;
